import { PluralItemType } from '../components/items/ItemsPage'
import { Edition } from '../models/Edition'
import { User } from '../models/User'

export const nextGoLiveStep = (me: User) => {
    if (me.onboardingState === 'ob_complete') {
        return '/golive/welcome'
    }
    if (me.onboardingState === 'gl_business') {
        return '/golive/business-info'
    }
    if (me.onboardingState === 'gl_personal') {
        return '/golive/personal-info'
    }
    if (me.onboardingState === 'gl_payouts') {
        return '/golive/receive-payouts'
    }

    if (me.onboardingState === 'gl_premium' && !me.plan) {
        return '/golive/select-plan'
    }
    // todo else { goto online booking eventually gl_widget }

    return '/golive/success'
}

export const getItemTypeFromPath = (path: string) => {
    const pluralType = path.split('/')[2] as PluralItemType
    switch (pluralType) {
        case 'services':
            return 'service'
        case 'products':
            return 'product'
        case 'classes':
            return 'class'
        case 'reservations':
            return 'reservation'
        case 'packages':
            return 'package'
        case 'subscriptions':
            return 'subscription'
        case 'gifts':
            return 'gift'
    }
}

export const editionDefaultsForType = (
    type: ReturnType<typeof getItemTypeFromPath>,
    edition?: Edition
) => {
    if (!edition) return []

    switch (type) {
        case 'service':
            return edition.defaultServices
        case 'product':
            return edition.defaultProducts
        case 'class':
            return edition.defaultClasses
        case 'reservation':
            return edition.defaultReservations
        case 'package':
            return edition.defaultPackages
        case 'subscription':
            return edition.defaultSubscriptions
        case 'gift':
            return edition.defaultGifts
    }
}

export const getRegExpForOnboardingPathsThatFollow = (path: string) => {
    const order = [
        'hours',
        'categories',
        'services',
        'classes',
        'reservations',
        'packages',
        'subscriptions',
        'products',
        'gifts',
        'forms',
        'contracts',
        'intake',
        'location',
        'payment',
        'payment-continued',
        'profile',
        'success',
    ]

    const index = order.indexOf(path)

    if (index === -1) {
        return /^\/onboarding/
    }

    const itemPaths = order.slice(index).join('|')

    return new RegExp(`^/onboarding/(${itemPaths}).*`)
}
